import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id E7B0A94D-5F09-4E77-A1E0-3DA131398A26
 * name cross-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cross-outline.svg
 * tags
 * - Religion 
 */
export const CrossOutlineIcon = createSvgIcon(<><path d="M15.5,6V1H8.5V6H3V13H8.5V23H15.5V13H21V6H15.5M19,11H13.5V21H10.5V11H5V8H10.5V3H13.5V8H19V11Z" /></>, 'CrossOutlineIcon');
export default CrossOutlineIcon